import { Module } from "wrapper6";
import Gumshoe from "gumshoejs";
var $ = jQuery;

export default class SmoothScroll extends Module {

	ready(app) {        
        
        $(document).on('click', '.product-nav a[href^="#"]', function (event) {            
            
            event.preventDefault();
        
            if ($('body').hasClass('single-product')) {
                $('html, body').animate({
                    scrollTop: $($.attr(this, 'href')).offset().top - 150
                }, 500);
            } else {
                $('html, body').animate({
                    scrollTop: $($.attr(this, 'href')).offset().top - 100
                }, 500);
            }
        });

        if (document.querySelector('.product-nav a')) {
            var singleProductSpy = new Gumshoe('.product-nav a', {
                offset: 150
            });
        }

    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_smooth_scroll.js